import { motion } from "framer-motion";
import { Users } from "lucide-react";
import SceneShell from "../components/SceneShell";
import CountUp from "../components/CountUp";

/**
 * Scene 39 — "We've got around 5,000 clients."
 */

export default function Scene39_FiveThousandClients() {
  return (
    <SceneShell variant="ink" align="center" data-testid="scene-5k-clients">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at center, rgba(212,148,10,0.16) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(233,168,32,0.26) 0%, transparent 55%)",
            "radial-gradient(ellipse at center, rgba(212,148,10,0.16) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1500px] mx-auto w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="kn-eyebrow mx-auto flex items-center justify-center gap-2"
        >
          <Users className="w-3.5 h-3.5" style={{ color: "#e9a820" }} />
          The base
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.7, filter: "blur(28px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.5, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="mt-10"
          data-testid="5k-clients-number"
        >
          <div
            className="kn-display tnum leading-[0.85]"
            style={{
              fontSize: "clamp(120px, 20vw, 320px)",
              background:
                "linear-gradient(135deg, #d4940a 0%, #e9a820 50%, #d4940a 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              textShadow: "0 0 100px rgba(233,168,32,0.45)",
              whiteSpace: "nowrap",
            }}
          >
            <CountUp from={0} to={5000} duration={2.4} startDelay={1.4} />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.0, delay: 2.4 }}
          className="mt-6 kn-display text-3xl sm:text-5xl lg:text-6xl text-white"
        >
          <span className="text-white/55">clients across the</span>{" "}
          <span style={{ color: "#e9a820" }}>portfolio.</span>
        </motion.div>
      </div>
    </SceneShell>
  );
}
